export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 18"
  height="18"
  width="18"
>
  <g
    transform="matrix(0.03156311,0,0,0.03156311,2.9398546,-8.3145754)"
  >
    <path
      d="m 358.286,310.857 q 0,7.429 -5.714,13.143 L 128.001,548.571 352.572,773.142 q 5.714,5.714 5.714,13.143 0,7.429 -5.714,13.143 l -28.571,28.571 q -5.714,5.714 -13.143,5.714 -7.429,0 -13.143,-5.714 L 31.429,561.713 q -5.714,-5.714 -5.714,-13.143 0,-7.429 5.714,-13.143 L 297.715,269.141 q 5.714,-5.714 13.143,-5.714 7.429,0 13.143,5.714 l 28.571,28.571 q 5.714,5.714 5.714,13.143 z"
    />
  </g>
</svg>`;
